import React, { useEffect, useState } from 'react';
import { validation } from '../../../../shared/validation/validation';
import { Input } from '..';
export var InputDob = function (_a) {
    var register = _a.register, required = _a.required, errors = _a.errors, setValue = _a.setValue, value = _a.value, name = _a.name, disabled = _a.disabled, isReset = _a.isReset;
    var _b = useState(), day = _b[0], setDay = _b[1];
    var _c = useState(), month = _c[0], setMonth = _c[1];
    var _d = useState(), year = _d[0], setYear = _d[1];
    useEffect(function () {
        setDay('');
        setMonth('');
        setYear('');
    }, [isReset]);
    useEffect(function () {
        var _a;
        if (value) {
            var date = value.split('-');
            setDay((_a = date[2]) === null || _a === void 0 ? void 0 : _a.split('T')[0]);
            setMonth(date[1]);
            setYear(date[0]);
        }
    }, [value]);
    return (React.createElement("div", { className: "l-flex" },
        React.createElement("div", null,
            React.createElement(Input, { id: "".concat(name, "Day"), error: errors && !!errors["".concat(name, "Day")], placeHolder: "DD", required: required, ref: register({ pattern: validation.dob.types.day.pattern, required: required }), setValue: setValue, value: day, disabled: disabled })),
        React.createElement("div", null,
            React.createElement(Input, { id: "".concat(name, "Month"), error: errors && !!errors["".concat(name, "Month")], placeHolder: "MM", required: required, ref: register({ pattern: validation.dob.types.month.pattern, required: required }), setValue: setValue, value: month, disabled: disabled })),
        React.createElement("div", null,
            React.createElement(Input, { id: "".concat(name, "Year"), error: errors && !!errors["".concat(name, "Year")], placeHolder: "YYYY", required: required, ref: register({ pattern: validation.dob.types.year.pattern, required: required }), setValue: setValue, value: year, disabled: disabled }))));
};
